import { Target, Users, Lightbulb, Rocket } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const Mission = () => {
  const challenges = [
    {
      id: 'limited-access',
      icon: Target,
      title: "Limited Access",
      description: "Few undergraduate programs offer comprehensive chip design coursework"
    },
    {
      id: 'industry-gap',
      icon: Users,
      title: "Industry Gap",
      description: "Disconnect between academic theory and real-world semiconductor practices"
    },
    {
      id: 'resource-scarcity',
      icon: Lightbulb,
      title: "Resource Scarcity",
      description: "Expensive tools and limited hands-on opportunities in microchip design"
    }
  ];

  return (
    <section id="mission" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Our Mission
          </h2>
          <div className="w-24 h-1 bg-[#BB0000] mx-auto mb-8"></div>
        </div>

        {/* The Challenge */}
        <div className="mb-20">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">The Challenge</h3>
            <p className="text-xl text-gray-700 leading-relaxed">
              Breaking into chip design as an undergraduate Electrical or Computer Engineering 
              student is incredibly challenging. The semiconductor industry demands specialized 
              knowledge and practical experience that traditional coursework alone cannot provide.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {challenges.map((challenge) => (
              <Card key={challenge.id} className="border-2 border-gray-200 hover:border-[#BB0000] transition-all hover:shadow-lg group">
                <CardContent className="p-8 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 group-hover:bg-[#BB0000]/10 rounded-full mb-6 transition-colors">
                    <challenge.icon className="text-[#BB0000]" size={32} />
                  </div>
                  <h4 className="text-xl font-bold text-gray-900 mb-3">{challenge.title}</h4>
                  <p className="text-gray-600 leading-relaxed">{challenge.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Our Solution */}
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-[#BB0000]/5 to-gray-100/50 rounded-3xl"></div>
          <div className="relative py-16 px-6 sm:px-12">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center justify-center mb-8">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-[#BB0000] rounded-full">
                  <Rocket className="text-white" size={40} />
                </div>
              </div>
              
              <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">Our Solution</h3>
              
              <p className="text-xl text-gray-700 leading-relaxed text-center mb-8">
                <span className="font-bold text-[#BB0000]">Buckeye Silicon</span> exists to bridge this gap. 
                We connect passionate undergraduate students with the resources, mentorship, and hands-on 
                experience necessary to build industry-relevant skills in microchip design.
              </p>

              <div className="bg-white rounded-xl p-8 shadow-lg border-2 border-[#BB0000]/20">
                <p className="text-lg text-gray-700 leading-relaxed text-center italic">
                  "Our mission is to democratize access to semiconductor education, fostering a community 
                  where students can explore cutting-edge chip design methodologies, collaborate on real-world 
                  projects, and prepare for successful careers in one of the most critical industries of our time."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
